import React from 'react'
import {IconText} from '../../../sharedComponents/components'
import {Button, ButtonRowGrid, ButtonRowWrap} from '../../../Components/Atoms/Buttons'
import {IconDelete} from '../../../Assets/Icons/TinyIcons'

interface ButtonRowProps {
  t: any
  isEditing: boolean
  disableSave: boolean
  cancel: () => void
  submit: () => Promise<void>
  update: () => Promise<void>
  setModalOpen: (isModalOpen: boolean) => void
}

export const ButtonRow = React.memo(
  ({t, isEditing, disableSave, submit, cancel, update, setModalOpen}: ButtonRowProps) => {
    return (
      <ButtonRowWrap>
        {isEditing ? (
          <IconText
            onClick={() => setModalOpen(true)}
            icon={<IconDelete />}
            text={t('messages:actions.deleteMessage', 'Delete Message')}
          />
        ) : (
          <div className="empty" />
        )}
        <ButtonRowGrid>
          <Button name="cancel-button" negative variant="secondary" disabled={false} onClick={cancel}>
            {t('common:buttons.cancel', 'Cancel')}
          </Button>
          <Button variant="secondary" disabled={disableSave} onClick={isEditing ? update : submit}>
            {t('common:buttons.save', 'Save')}
          </Button>
        </ButtonRowGrid>
      </ButtonRowWrap>
    )
  }
)
